/*
 * Copyright © 2021 Lexcelon LLC <info@lexcelon.com>
 * Licensed for non-distributable use
 */
export function isSelected(currentPathname, slug) {
  return currentPathname === '/' && slug === '/'
    ? true
    : currentPathname.toLowerCase() === slug.toLowerCase() && slug !== '/';
}